export const sidebarActionType = {   
    OPEN_SIDEBARNAV: 'OPEN_SIDEBARNAV',
    CLOSE_SIDEBARNAV: 'CLOSE_SIDEBARNAV',
    TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS'
};